import { Box, IconButton, Popover, Stack, Typography } from "@mui/material"
import { If } from "lib/@components/if"
import { Repeat } from "lib/@components/repeat"
import Iconify from "minimals-template/components/Iconify"
import {
    getProjectBridgeCanonicalStatusLabel,
    getProjectBridgeCanonicalUsageDefinition,
} from "./project-bridge-rewrite-card-presenters"
import { ProjectBridgeCanonicalUsagePopoverItem } from "./project-bridge-canonical-usage-popover-item"

export function ProjectBridgeCanonicalUsagePopover({ anchorEl, open, item, onClose }) {
    const title = getProjectBridgeCanonicalStatusLabel(item)
    const definition = getProjectBridgeCanonicalUsageDefinition(item)
    const usage = item?.canonicalUsage || {}
    const items = Array.isArray(usage.items) ? usage.items : []
    const titleId = `project-bridge-canonical-usage-${item?.changeId || "popover"}`

    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            PaperProps={{ sx: { width: 420, maxWidth: "calc(100vw - 32px)" } }}
        >
            <Box role="dialog" aria-labelledby={titleId} sx={{ p: 2 }}>
                <Stack spacing={1.5}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
                        <Typography id={titleId} variant="subtitle2">
                            {title}
                        </Typography>
                        <IconButton size="small" onClick={onClose} aria-label="Close shared rewrite details">
                            <Iconify icon="mdi:close" />
                        </IconButton>
                    </Stack>

                    <Typography variant="body2" color="text.secondary">
                        {definition}
                    </Typography>

                    <Typography variant="caption" color="text.secondary">
                        {buildUsageSummary()}
                    </Typography>

                    <Stack spacing={0.5}>
                        <Repeat
                            list={items}
                            item={<ProjectBridgeCanonicalUsagePopoverItem />}
                            keyFn={getUsageItemKey}
                        />
                    </Stack>

                    <If truthy={usage.truncated}>
                        <Typography variant="caption" color="text.secondary">
                            Showing the first {items.length} of {Number(usage.totalCount || 0)} schedules.
                        </Typography>
                    </If>
                </Stack>
            </Box>
        </Popover>
    )

    function buildUsageSummary() {
        const totalCount = Number(usage.totalCount || 0)
        if (totalCount === 1) return "Used in 1 schedule."
        return `Used in ${totalCount} schedules.`
    }

    function getUsageItemKey(usageItem) {
        return usageItem?.key || `${usageItem?.overlapId || ""}:${usageItem?.changeId || ""}`
    }
}
